import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/product-detail/components/ProductDetailKeyed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/components/Header.tsx");
